import React from 'react';
import { Box, Skeleton } from '@mui/material';

interface DonutChartSkeletonProps {
  height?: number;
  donutSize?: number;
  legendItems?: number;
}

export const DonutChartSkeleton: React.FC<DonutChartSkeletonProps> = ({
  height = 420,
  donutSize = 240,
  legendItems = 2,
}) => {
  return (
    <Box
      sx={{
        borderRadius: 1,
        border: 1,
        borderColor: 'divider',
        p: 4,
        height,
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0, minWidth: 0 }}>
        <Skeleton variant="text" width="45%" height={28} />
      </Box>

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          mt: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            height: `min(100%, ${donutSize}px)`,
            width: `min(100%, ${donutSize}px)`,
            aspectRatio: '1 / 1',
            position: 'relative',
            flexShrink: 1,
          }}
        >
          <Skeleton variant="circular" sx={{ width: '100%', height: '100%' }} />
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '55%',
              height: '55%',
              borderRadius: '50%',
              bgcolor: 'background.paper',
            }}
          />
        </Box>
      </Box>

      <Box
        sx={{
          mt: 2,
          display: 'flex',
          gap: 4,
          alignItems: 'center',
          flexWrap: 'wrap',
          flexShrink: 0,
          minWidth: 0,
        }}
      >
        {Array.from({ length: legendItems }).map((_, i) => (
          <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
            <Skeleton variant="rectangular" width={18} height={18} />
            <Skeleton variant="text" width={110} height={22} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};